import type { CampaignStatusModel, PendingChangesResult } from 'entities/campaign';
import { AlertBox } from 'shared/ui/AlertBox';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { useContractorDateWithTimeZone } from 'shared/lib/timezones';

interface HighlightedChangesInfoProps {
  appliesAt: string | null;
  pendingChanges: PendingChangesResult;
  status: CampaignStatusModel;
}

export function HighlightedChangesInfo({
  appliesAt,
  pendingChanges: { budget, zipCodes, schedule, minimalIncome },
  status,
}: HighlightedChangesInfoProps) {
  const shouldShow = budget || zipCodes || schedule || minimalIncome;
  const getPendingDate = useContractorDateWithTimeZone();
  const formattedAppliesAt = appliesAt && getPendingDate(appliesAt);

  return (
    <>
      {shouldShow && (
        <AlertBox
          className="mt-4 border-orange-100"
          iconClass="text-orange-500"
          iconName="update"
        >
          <div className="text-sm">
            <div {...getDataAutoTestAttributes(['campaign-highlighted-changes']).attributes}>
              {status !== 'deactivated' && (
                <div className="text-slate-700">Highlighted changes will be applied on {formattedAppliesAt}.</div>
              )}
              {status === 'deactivated' && (
                <div className="text-slate-700">
                  Highlighted changes will be applied after campaign activation but not earlier than the following{' '}
                  {formattedAppliesAt}.
                </div>
              )}
            </div>
            <a
              href="/"
              className="mt-2 hidden font-semibold text-slate-700 underline"
            >
              Learn more
            </a>
          </div>
        </AlertBox>
      )}
    </>
  );
}
